import React from 'react';
import PropTypes from 'prop-types';
import { ForgeIcon } from '@tylertech/forge-react';

const TableCellTextWithIcon = ({ icon, text }) => {
  return (
    <>
      <ForgeIcon
        external
        externalType="all"
        name={icon}
        className="opacity54"
        style={{ marginRight: '5px', verticalAlign: 'middle' }}
      />
      <span style={{ verticalAlign: 'middle' }}>{text}</span>
    </>
  );
};

TableCellTextWithIcon.propTypes = {
  icon: PropTypes.string,
  text: PropTypes.string,
};

export default TableCellTextWithIcon;
